import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from './customModal';

//API Calls
const { apiActualizarMail } = require('../../utils/APIs/APISResume')

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalEmail = (props)=>{
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [observacion, setObservacion]= useState('')

    const cambioEstadoEnDB = async () => {
        try {
            let body = {
                email: props.email,
                userId: userData.userId,
                cod_empr: userData.codigoEmpresa
            }
            await apiActualizarMail(body)
        }
        catch (error) {
            toastError('Error al Actualizar!')
            console.log(error)
        }
        toastSuccess('Correo Actualizado!')
    }
    const cambiarEmailEnDB =()=>{
        try {
            cambioEstadoEnDB()
            props.toggle()
        }
        catch (error) {
            console.log(error)
        }
        
    }
    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Actualizar Email'}
                buttonTitle={'Actualizar'}
                size={'md'}
                onClick={() => cambiarEmailEnDB()}
            >
                <div className={'updateEmail-modal-body'}>
                    ¿Desea actualizar su correo en KACTUS por {props.email}?
                </div>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalEmail);